import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../Components/SEO'
import ServicesSidebar from '../Components/ServicesSidebar'

const Services = () => {
    return (
        <div>
            <SEO
                title="Transportation Services Dubai | Freezer, Chiller, Mover & Trailer Services Dubai - Best in UAE"
                description="Best Transportation Services in Dubai, UAE. Professional Freezer Transportation, Chiller Transportation, Mover Transportation & Trailer Transportation in Dubai. Serving Downtown Dubai, JBR, Business Bay, Dubai Marina & All Areas. 24/7 Service. Call +971555592206"
                keywords="transportation services Dubai, freezer transportation Dubai, chiller transportation Dubai, mover transportation Dubai, trailer transportation Dubai, freezer van Dubai, chiller truck Dubai, moving services Dubai, trailer services Dubai, transportation company Dubai, best transport Dubai, top transport company Dubai, freezer transportation services Dubai, chiller transportation services Dubai, mover transportation services Dubai, trailer transportation services Dubai, cold chain logistics Dubai, temperature controlled transport Dubai, relocation services Dubai, heavy duty trailers Dubai, cotton box trailers Dubai, flat bed trailers Dubai, transport company Dubai, logistics services Dubai, cargo transport Dubai, freight services Dubai, refrigerated transport Dubai, frozen goods transport Dubai, perishable goods transport Dubai, office relocation Dubai, home moving Dubai, commercial transport Dubai, industrial transport Dubai, transportation near me Dubai, professional transport Dubai, reliable transport Dubai, affordable transport Dubai"
            />
            <div className="page-title-style01 page-title-negative-top pt-bkg03">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h1>Our Transportation Services</h1>
                            <div className="breadcrumb-container">
                                <ul className="breadcrumb clearfix">
                                    <li>You are here:</li>
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <Link to="/services-overview">Services</Link>
                                    </li>
                                </ul>
                                {/* .breadcrumb end */}
                            </div>
                            {/* .breadcrumb-container end */}
                        </div>
                        {/* .col-md-12 end */}
                    </div>
                    {/* .row end */}
                </div>
                {/* .container end */}
            </div>



            <div className="page-content">
                <div className="container">
                    <div className="row">
                        <aside className="col-md-3 aside aside-left">
                            <ServicesSidebar />
                        </aside>
                        {/* .aside.aside-left end */}
                        <div className="col-md-9">
                               <div className="custom-heading">
                                   <h2>COMPREHENSIVE TRANSPORTATION SERVICES ACROSS UAE</h2>
                               </div>
                               {/* .custom-heading end */}
                               <p>
                                   KD General Transport LLC offers a complete range of professional 
                                   transportation services throughout the United Arab Emirates. Our 
                                   diverse fleet includes specialized vehicles for every transportation 
                                   need, from temperature-controlled freezer and chiller vans to 
                                   moving trucks and heavy-duty trailers.
                               </p>
                               <p>
                                   With years of experience serving businesses and individuals across 
                                   all seven Emirates, we have built a reputation for reliability, 
                                   professionalism, and exceptional customer service. Whether you need 
                                   to transport frozen goods, temperature-sensitive products, relocate 
                                   your home or office, or move large-scale cargo, we have the right 
                                   vehicle and expertise for your requirements.
                               </p>
                               <ul className="fa-ul">
                                   <li>
                                       <i className="fa fa-li fa-long-arrow-right" />
                                       Freezer Van Services - 3 Ton, 7 Ton, 10 Ton trucks and trailers
                                   </li>
                                   <li>
                                       <i className="fa fa-li fa-long-arrow-right" />
                                       Chiller Truck Services - Temperature-controlled transportation
                                   </li>
                                   <li>
                                       <i className="fa fa-li fa-long-arrow-right" />
                                       Moving Services - 1 Ton, 1.5 Ton, 3 Ton, and 10 Ton trucks
                                   </li>
                                   <li>
                                       <i className="fa fa-li fa-long-arrow-right" />
                                       Trailer Services - Cotton box and flat bed trailers
                                   </li>
                                   <li>
                                       <i className="fa fa-li fa-long-arrow-right" />
                                       Coverage across all Emirates - Dubai, Abu Dhabi, Sharjah, and more
                                   </li>
                                   <li>
                                       <i className="fa fa-li fa-long-arrow-right" />
                                       24/7 customer support and flexible scheduling
                                   </li>
                               </ul>
                               {/* .fa-ul end */}
                               <br />
                               <p>
                                   Our team of experienced drivers and logistics professionals ensures 
                                   that every shipment is handled with care and delivered on time. We 
                                   maintain strict quality standards and regularly service our fleet to 
                                   guarantee optimal performance and reliability.
                               </p>
                               <p>
                                   At KD General Transport, we understand that your cargo is valuable, 
                                   whether it's perishable food items, sensitive pharmaceuticals, 
                                   personal belongings, or commercial goods. That's why we invest in 
                                   modern equipment, comprehensive insurance, and continuous training for 
                                   our staff to provide you with peace of mind and exceptional service.
                               </p>
                        </div>
                        {/* .col-md-9 end */}
                    </div>
                    {/* .row end */}
                </div>
                {/* .container end */}
            </div>



            <div className="page-content custom-bkg bkg-light-blue mb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-full-img">
                            <img src={`${process.env.PUBLIC_URL}/img/cars/freezer2.jpeg`} alt="KD General Transport Fleet" />
                        </div>
                        {/* .col-md-6 end */}
                        <div className="col-md-6">
                            <div className="custom-heading">
                                <h2>KD GENERAL TRANSPORT - YOUR TRUSTED PARTNER</h2>
                            </div>
                            {/* .custom-heading end */}
                            <p className="text-big">
                                Welcome to KD General Transport LLC, your premier transportation 
                                partner serving businesses and individuals across all seven Emirates 
                                of the UAE.
                            </p>
                            <p>
                                With a comprehensive fleet of specialized vehicles and years of 
                                experience in the UAE transportation industry, we provide reliable, 
                                professional, and cost-effective solutions for all your transportation 
                                needs. From temperature-controlled freezer and chiller services to 
                                moving and relocation, and heavy-duty trailer transportation, we 
                                ensure your goods are delivered safely and on time.
                            </p>
                        </div>
                        {/* .col-md-6.custom-col-padding end */}
                    </div>
                    {/* .row end */}
                </div>
                {/* .container end */}
            </div>




            <div className="page-content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <div className="custom-heading">
                                <h2>WHY CHOOSE KD GENERAL TRANSPORT</h2>
                            </div>
                            {/* .custom-heading end */}
                            <ul className="fa-ul large-icons">
                                <li>
                                    <div
                                        className="icon-container animated triggerAnimation"
                                        data-animate="zoomIn"
                                    >
                                        <i className="fa fa-check-circle" />
                                    </div>
                                    <div className="li-content">
                                        <h3>Comprehensive Fleet Coverage</h3>
                                        <p>
                                            Our diverse fleet includes freezer vans, chiller trucks, 
                                            moving vehicles, and trailers in various sizes (1 ton to 
                                            10 ton) to meet every transportation requirement across UAE.
                                        </p>
                                    </div>
                                    {/* .li-content end */}
                                </li>
                                <li>
                                    <div
                                        className="icon-container animated triggerAnimation"
                                        data-animate="zoomIn"
                                    >
                                        <i className="fa fa-check-circle" />
                                    </div>
                                    <div className="li-content">
                                        <h3>Temperature-Controlled Excellence</h3>
                                        <p>
                                            Advanced refrigeration systems in our freezer and chiller 
                                            vans ensure your perishable goods maintain optimal 
                                            temperature from pickup to delivery, maintaining the 
                                            integrity of your cold chain.
                                        </p>
                                    </div>
                                    {/* .li-content end */}
                                </li>
                                <li>
                                    <div
                                        className="icon-container animated triggerAnimation"
                                        data-animate="zoomIn"
                                    >
                                        <i className="fa fa-check-circle" />
                                    </div>
                                    <div className="li-content">
                                        <h3>Safety &amp; Reliability</h3>
                                        <p>
                                            All our vehicles are regularly maintained, fully insured, 
                                            and operated by experienced, certified drivers. We 
                                            prioritize safety and compliance with UAE transportation 
                                            regulations.
                                        </p>
                                    </div>
                                    {/* .li-content end */}
                                </li>
                            </ul>
                            {/* .fa-ul .fa-ul-large end */}
                        </div>
                        {/* .col-md-5 end */}
                        <div
                            className="col-md-7 triggerAnimation animated"
                            data-animate="fadeInRight"
                        >
                            <img src={`${process.env.PUBLIC_URL}/img/cars/chiller2.jpeg`} alt="KD General Transport Services" />
                        </div>
                        {/* .col-md-7 end */}
                    </div>
                    {/* .row end */}
                </div>
                {/* .container end */}
            </div>



            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="custom-heading02">
                                <h2>Our services</h2>
                                <p>PROFESSIONAL TRANSPORTATION SOLUTIONS ACROSS UAE</p>
                            </div>
                            {/* .custom-heading02 end */}
                        </div>
                        {/* .col-md-12 end */}
                    </div>
                    {/* .row end */}
                    <div className="row mb-0">
                        <ul className="services-gallery clearfix">
                            <li className="col-md-3">
                                <figure className="service-item-container">
                                    <div className="service-item">
                                        <img src={`${process.env.PUBLIC_URL}/img/cars/freezer2.jpeg`} alt="Freezer Services" />
                                        <div className="hover-mask-container">
                                            <div className="hover-mask" />
                                            <div
                                                className="hover-details"
                                                style={{ marginLeft: "-78.5px" }}
                                            >
                                                <a 
                                                    href="https://wa.me/971507907682?text=Hi%20KD%20General%20Transport!%20I%20want%20to%20inquire%20about%20Freezer%20Services."
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <span>Book Now</span>
                                                </a>
                                            </div>
                                            {/* .hover-details end */}
                                        </div>
                                        {/* .hover-mask-container end */}
                                    </div>
                                    {/* .service-item end */}
                                    <figcaption>
                                        <h3>FREEZER SERVICES</h3>
                                    </figcaption>
                                </figure>
                                {/* .service-item end */}
                            </li>
                            {/* .service-item end */}
                            <li className="col-md-3">
                                <figure className="service-item-container">
                                    <div className="service-item">
                                        <img src={`${process.env.PUBLIC_URL}/img/cars/chiller2.jpeg`} alt="Chiller Services" />
                                        <div className="hover-mask-container">
                                            <div className="hover-mask" />
                                            <div
                                                className="hover-details"
                                                style={{ marginLeft: "-78.5px" }}
                                            >
                                                <a 
                                                    href="https://wa.me/971507907682?text=Hi%20KD%20General%20Transport!%20I%20want%20to%20inquire%20about%20Chiller%20Services."
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <span>Book Now</span>
                                                </a>
                                            </div>
                                            {/* .hover-details end */}
                                        </div>
                                        {/* .hover-mask-container end */}
                                    </div>
                                    {/* .service-item end */}
                                    <figcaption>
                                        <h3>CHILLER SERVICES</h3>
                                    </figcaption>
                                </figure>
                                {/* .service-item end */}
                            </li>
                            {/* .service-item end */}
                            <li className="col-md-3">
                                <figure className="service-item-container">
                                    <div className="service-item">
                                        <img src={`${process.env.PUBLIC_URL}/img/cars/mover2.jpeg`} alt="Moving Services" />
                                        <div className="hover-mask-container">
                                            <div className="hover-mask" />
                                            <div
                                                className="hover-details"
                                                style={{ marginLeft: "-78.5px" }}
                                            >
                                                <a 
                                                    href="https://wa.me/971507907682?text=Hi%20KD%20General%20Transport!%20I%20want%20to%20inquire%20about%20Moving%20Services."
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <span>Book Now</span>
                                                </a>
                                            </div>
                                            {/* .hover-details end */}
                                        </div>
                                        {/* .hover-mask-container end */}
                                    </div>
                                    {/* .service-item end */}
                                    <figcaption>
                                        <h3>MOVING SERVICES</h3>
                                    </figcaption>
                                </figure>
                                {/* .service-item end */}
                            </li>
                            {/* .service-item end */}
                            <li className="col-md-3">
                                <figure className="service-item-container">
                                    <div className="service-item">
                                        <img src={`${process.env.PUBLIC_URL}/img/cars/trailer1.jpeg`} alt="Trailer Services" />
                                        <div className="hover-mask-container">
                                            <div className="hover-mask" />
                                            <div
                                                className="hover-details"
                                                style={{ marginLeft: "-78.5px" }}
                                            >
                                                <a 
                                                    href="https://wa.me/971507907682?text=Hi%20KD%20General%20Transport!%20I%20want%20to%20inquire%20about%20Trailer%20Services."
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <span>Book Now</span>
                                                </a>
                                            </div>
                                            {/* .hover-details end */}
                                        </div>
                                        {/* .hover-mask-container end */}
                                    </div>
                                    {/* .service-item end */}
                                    <figcaption>
                                        <h3>TRAILER SERVICES</h3>
                                    </figcaption>
                                </figure>
                                {/* .service-item end */}
                            </li>
                            {/* .service-item end */}
                        </ul>
                        {/* #services-gallery end */}
                    </div>
                    {/* .row end */}
                </div>
                {/* .container-fluid end */}
            </div>

        </div>
    )
}

export default Services
